console.log("AI Fuzzy Matching Engine Loaded");


//================================================
// FUZZY MATCHING CONFIGURATION
//================================================

const FUZZY_CONFIG = {

    // Maximum normalized edit distance
    // Lower = stricter matching
    MAX_DISTANCE_RATIO: 0.30,

    // Don't fuzzy-correct very short words
    MIN_WORD_LENGTH: 4,

    // Maximum number of suggestions
    MAX_SUGGESTIONS: 1

};


//================================================
// AI VOCABULARY
//================================================

const AI_FUZZY_VOCABULARY = [

    // -----------------------------------------
    // GENERAL PRODUCT TERMS
    // -----------------------------------------

    "camera",
    "cameras",
    "cctv",
    "security",
    "security camera",

    "indoor",
    "outdoor",

    "bulb",
    "ptz",
    "dome",
    "bullet",
    "hidden",
    "spy",

    "doorbell",

    "gps",
    "tracker",

    "lock",
    "fingerprint",

    "sensor",
    "alarm",

    "light",
    "switch",

    "watch",


    // -----------------------------------------
    // LOCATIONS
    // -----------------------------------------

    "home",
    "house",
    "apartment",
    "flat",
    "villa",
    "bungalow",
    "office",
    "shop",
    "store",
    "garden",
    "warehouse",
    "godown",
    "factory",
    "school",
    "college",
    "hospital",
    "medical",
    "pharmacy",
    "jewellery",
    "jewelry",
    "supermarket",
    "grocery",
    "mart",


    // -----------------------------------------
    // FEATURES
    // -----------------------------------------

    "wifi",
    "bluetooth",
    "4g",
    "5g",

    "night",
    "vision",

    "human",
    "detection",
    "motion",

    "audio",
    "microphone",
    "speaker",

    "battery",

    "solar",

    "waterproof",

    "weatherproof",

    "wireless",

    "ethernet",

    "sim",

    "cloud",

    "storage",

    "memory",

    "sd",

    "card",

    "remote",

    "monitoring",

    "recording",

    "alarm",

    "notification",

    "notifications",

    "tracking",

    "gps",

    "zoom",

    "pan",

    "tilt",

    "360",

    "full",

    "color",

    "colour",


    // -----------------------------------------
    // RESOLUTION
    // -----------------------------------------

    "1080p",
    "2mp",
    "3mp",
    "4mp",
    "5mp",
    "8mp",
    "12mp",
    "16mp",


    // -----------------------------------------
    // SHOPPING TERMS
    // -----------------------------------------

    "cheap",
    "cheapest",
    "budget",
    "price",
    "under",
    "below",
    "above",
    "lowest",
    "highest",

    "best",
    "better",
    "recommend",
    "recommended",

    "compare",
    "difference",

    "feature",
    "features",

    "warranty",

    "install",
    "installation",


    // -----------------------------------------
    // COMMON WORDS USED IN REQUESTS
    // -----------------------------------------

    "need",
    "want",
    "looking",
    "looking for",

    "with",
    "without",

    "for",
    "my",

    "camera",
    "cameras"

];

//================================================
// PRODUCT CATALOG VOCABULARY
//================================================

function buildProductVocabulary(){

    const vocabulary = new Set(
        AI_FUZZY_VOCABULARY
            .map(word =>
                word.toLowerCase().trim()
            )
    );


    //--------------------------------------------
    // Make sure ALL_PRODUCTS exists
    //--------------------------------------------

    if(
        typeof ALL_PRODUCTS === "undefined" ||
        !Array.isArray(ALL_PRODUCTS)
    ){

        console.warn(
            "ALL_PRODUCTS not available for fuzzy vocabulary."
        );

        return Array.from(vocabulary);

    }


    //--------------------------------------------
    // Read every product
    //--------------------------------------------

    ALL_PRODUCTS.forEach(product => {


        //----------------------------------------
        // PRODUCT TITLE
        //----------------------------------------

        if(product.title){

            addProductVocabularyWords(
                product.title,
                vocabulary
            );

        }


        //----------------------------------------
        // PRODUCT TYPE
        //----------------------------------------

        if(product.product_type){

            addProductVocabularyWords(
                product.product_type,
                vocabulary
            );

        }


        //----------------------------------------
        // PRODUCT TAGS
        //----------------------------------------

        if(
            Array.isArray(product.tags)
        ){

            product.tags.forEach(tag => {

                addProductVocabularyWords(
                    tag,
                    vocabulary
                );

            });

        }

    });


    console.log(
        "AI Product Vocabulary Loaded:",
        vocabulary.size
    );


    return Array.from(vocabulary);

}


//================================================
// ADD PRODUCT TERMS
//================================================

function addProductVocabularyWords(
    text,
    vocabulary
){

    if(!text){

        return;

    }


    //--------------------------------------------
    // Convert to lowercase
    //--------------------------------------------

    text =
        String(text)
            .toLowerCase()
            .trim();


    //--------------------------------------------
    // Add complete phrase
    //--------------------------------------------

    if(
        text.length >= 4
    ){

        vocabulary.add(text);

    }


    //--------------------------------------------
    // Add individual words
    //--------------------------------------------

    const words =
        text.split(/[\s,|/()\-]+/);


    words.forEach(word => {

        word =
            word
                .trim()
                .replace(
                    /[^a-z0-9]/gi,
                    ""
                );


        //----------------------------------------
        // Ignore very short words
        //----------------------------------------

        if(
            word.length >=
            FUZZY_CONFIG.MIN_WORD_LENGTH
        ){

            vocabulary.add(word);

        }

    });

}


//================================================
// BUILD PRODUCT VOCABULARY
//================================================

//================================================
// GET CURRENT FUZZY VOCABULARY
//================================================

function getCompleteFuzzyVocabulary(){

    const vocabulary = new Set(
        AI_FUZZY_VOCABULARY
    );


    //--------------------------------------------
    // ALL_PRODUCTS may be loaded later
    //--------------------------------------------

    if(
        typeof ALL_PRODUCTS !== "undefined" &&
        Array.isArray(ALL_PRODUCTS)
    ){

        ALL_PRODUCTS.forEach(product => {

            //------------------------------------
            // TITLE
            //------------------------------------

            if(product.title){

                addProductVocabularyWords(
                    product.title,
                    vocabulary
                );

            }


            //------------------------------------
            // PRODUCT TYPE
            //------------------------------------

            if(product.product_type){

                addProductVocabularyWords(
                    product.product_type,
                    vocabulary
                );

            }


            //------------------------------------
            // TAGS
            //------------------------------------

            if(
                Array.isArray(product.tags)
            ){

                product.tags.forEach(tag => {

                    addProductVocabularyWords(
                        tag,
                        vocabulary
                    );

                });

            }

        });

    }


    return Array.from(vocabulary);
}


console.log(
    "Complete AI Fuzzy Vocabulary:",
    AI_COMPLETE_FUZZY_VOCABULARY.length
);


//================================================
// LEVENSHTEIN DISTANCE
//================================================

function fuzzyLevenshtein(a, b){

    const matrix = [];


    //-----------------------------------------
    // INITIALIZE
    //-----------------------------------------

    for(let i = 0; i <= b.length; i++){

        matrix[i] = [i];

    }


    for(let j = 0; j <= a.length; j++){

        matrix[0][j] = j;

    }


    //-----------------------------------------
    // CALCULATE DISTANCE
    //-----------------------------------------

    for(let i = 1; i <= b.length; i++){

        for(let j = 1; j <= a.length; j++){

            if(
                b.charAt(i - 1) ===
                a.charAt(j - 1)
            ){

                matrix[i][j] =
                    matrix[i - 1][j - 1];

            }
            else{

                matrix[i][j] =
                    Math.min(

                        matrix[i - 1][j] + 1,

                        matrix[i][j - 1] + 1,

                        matrix[i - 1][j - 1] + 1

                    );

            }

        }

    }


    return matrix[b.length][a.length];

}


//================================================
// NORMALIZED DISTANCE RATIO
//================================================

function fuzzyDistanceRatio(word, candidate){

    const distance =
        fuzzyLevenshtein(
            word,
            candidate
        );


    const maxLength =
        Math.max(
            word.length,
            candidate.length
        );


    if(maxLength === 0){

        return 0;

    }


    return distance / maxLength;

}


//================================================
// FIND BEST FUZZY MATCH
//================================================

function findBestFuzzyMatch(word){

    const vocabulary =
    getCompleteFuzzyVocabulary();

    if(!word){

        return null;

    }


    word =
        word.toLowerCase().trim();


    //-----------------------------------------
    // EXACT MATCH
    //-----------------------------------------

   if(
    vocabulary.includes(word)
){

        return {

            word: word,

            matchedWord: word,

            distance: 0,

            ratio: 0,

            exact: true

        };

    }


    //-----------------------------------------
    // IGNORE NUMBERS
    //-----------------------------------------

    if(
        /^[0-9]+$/.test(word)
    ){

        return null;

    }


    //-----------------------------------------
    // IGNORE SHORT WORDS
    //-----------------------------------------

    if(
        word.length <
        FUZZY_CONFIG.MIN_WORD_LENGTH
    ){

        return null;

    }


    let bestMatch = null;


    //-----------------------------------------
    // SEARCH VOCABULARY
    //-----------------------------------------

  for(
    const candidate
    of vocabulary
){

        // Don't compare words of very
        // different lengths.

        if(
            Math.abs(
                word.length -
                candidate.length
            ) > 3
        ){

            continue;

        }


        const ratio =
            fuzzyDistanceRatio(
                word,
                candidate
            );


        //-------------------------------------
        // BETTER MATCH
        //-------------------------------------

        if(
            !bestMatch ||
            ratio < bestMatch.ratio
        ){

            bestMatch = {

                word: word,

                matchedWord: candidate,

                distance:
                    Math.round(
                        ratio *
                        Math.max(
                            word.length,
                            candidate.length
                        )
                    ),

                ratio: ratio,

                exact: false

            };

        }

    }


    //-----------------------------------------
    // NO SAFE MATCH
    //-----------------------------------------

    if(
        !bestMatch ||
        bestMatch.ratio >
        FUZZY_CONFIG.MAX_DISTANCE_RATIO
    ){

        return null;

    }


    return bestMatch;

}


//================================================
// NORMALIZE CUSTOMER MESSAGE
//================================================

function fuzzyNormalizeMessage(message){

    if(!message){

        return "";

    }


    const original =
        message;


    let normalized =
        message
            .toLowerCase()
            .trim();


    //-----------------------------------------
    // NORMALIZE WIFI
    //-----------------------------------------

    normalized =
        normalized.replace(
            /\bwi[\s-]?fi\b/gi,
            "wifi"
        );


    //-----------------------------------------
    // TOKENIZE
    //-----------------------------------------

    const words =
        normalized.split(/\s+/);


    const correctedWords = [];


    //-----------------------------------------
    // CORRECT EACH WORD
    //-----------------------------------------

    for(
        const originalWord
        of words
    ){

        //-------------------------------------
        // Remove punctuation for matching
        //-------------------------------------

        const cleanWord =
            originalWord
                .replace(
                    /^[^a-z0-9]+|[^a-z0-9]+$/gi,
                    ""
                );


        //-------------------------------------
        // Empty token
        //-------------------------------------

        if(!cleanWord){

            correctedWords.push(
                originalWord
            );

            continue;

        }


        //-------------------------------------
        // FIND FUZZY MATCH
        //-------------------------------------

        const match =
            findBestFuzzyMatch(
                cleanWord
            );


        //-------------------------------------
        // MATCH FOUND
        //-------------------------------------

        if(match){

            //---------------------------------
            // Preserve punctuation
            //---------------------------------

            const prefix =
                originalWord.match(
                    /^[^a-z0-9]*/i
                )?.[0] || "";


            const suffix =
                originalWord.match(
                    /[^a-z0-9]*$/i
                )?.[0] || "";


            correctedWords.push(

                prefix +

                match.matchedWord +

                suffix

            );


            //---------------------------------
            // Log correction
            //---------------------------------

            if(
                !match.exact
            ){

                console.log(
                    "Fuzzy Correction:",
                    cleanWord,
                    "→",
                    match.matchedWord,
                    "Distance:",
                    match.distance,
                    "Ratio:",
                    match.ratio.toFixed(2)
                );

            }

        }
        else{

            //---------------------------------
            // Keep original word
            //---------------------------------

            correctedWords.push(
                originalWord
            );

        }

    }


    //-----------------------------------------
    // BUILD MESSAGE
    //-----------------------------------------

    normalized =
        correctedWords.join(" ");


    //-----------------------------------------
    // COMMON PHRASE NORMALIZATION
    //-----------------------------------------

    normalized =
        normalized

            .replace(
                /\bbulb\s+camera\b/gi,
                "bulb camera"
            )

            .replace(
                /\boutdoor\s+camera\b/gi,
                "outdoor camera"
            )

            .replace(
                /\bindoor\s+camera\b/gi,
                "indoor camera"
            )

            .replace(
                /\bnight\s+vision\b/gi,
                "night vision"
            )

            .replace(
                /\bhuman\s+detection\b/gi,
                "human detection"
            );


    //-----------------------------------------
    // LOG FINAL MESSAGE
    //-----------------------------------------

    console.log(
        "Original Message:",
        original
    );

    console.log(
        "Fuzzy Normalized Message:",
        normalized
    );


    return normalized;

}


//================================================
// GET FUZZY CORRECTIONS
// Useful for debugging / UI
//================================================

function getFuzzyCorrections(message){

    if(!message){

        return [];

    }


    const corrections = [];

    const words =
        message
            .toLowerCase()
            .trim()
            .split(/\s+/);


    for(
        const word
        of words
    ){

        const cleanWord =
            word.replace(
                /^[^a-z0-9]+|[^a-z0-9]+$/gi,
                ""
            );


        const match =
            findBestFuzzyMatch(
                cleanWord
            );


        if(
            match &&
            !match.exact
        ){

            corrections.push({

                original: cleanWord,

                corrected:
                    match.matchedWord,

                distance:
                    match.distance,

                ratio:
                    match.ratio

            });

        }

    }


    return corrections;

}